import React, { Component } from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { ToastContainer, toast } from "react-toastify";
import $ from 'jquery';

class WidgetLogo extends Component {
  constructor() {
    super(...arguments);
    this.dialogClose = () => {
      this.setState({ hideWidgetLogoDialog: false, hideDeletePopup: false });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.state = {
      selectedFile: null,
      imagePreviewUrl: null,
      isOpen: false,
      dataUrl: null,
      currentLogoId: '',
      result: null,
      hideWidgetLogoDialog: false,
      hideDeletePopup: false,
      imagePreview: false,
    };
    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteWidgetLogoApi()
      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];
  }
  imagePreviewDataUrl(event) {

    let reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        dataUrl: reader.result
      });

    }
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  notifyImageSize() {
    toast(<b>File too Big, please select a file less than 4mb</b>, {
      position: "top-center",
      color: "#007aff"

    });
  }
  notifyImageType() {
    toast(<b>Please upload file having extensions .jpeg/.jpg/.png/.gif/.svg only.</b>, {
      position: "top-center",
      color: "#007aff"

    });
  }

  fileChangedHandler = event => {
    this.imagePreviewDataUrl(event);
    var imagePath = document.getElementById("inputFile").value;
    const fi = document.getElementById('inputFile');
    var imagetype = imagePath.split('.')[1];
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg)$/i;
    if (fi.files.length > 0) {
      for (var i = 0; i <= fi.files.length - 1; i++) {

        const fsize = fi.files.item(i).size;
        const file = Math.round((fsize / 1024));
        if (file >= 4096) {
          this.notifyImageSize();
        }
      }
      if (!allowedExtensions.exec(imagePath)) {
        this.notifyImageType();
      } else {

        this.setState({
          selectedFile: event.target.files[0]
        })

        let reader = new FileReader();

        reader.onloadend = () => {
          this.setState({
            imagePreviewUrl: reader.result
          });

        }
        reader.readAsBinaryString(event.target.files[0]);

      }
    }
  }
  notifyWidgetSuccessMsg(propertyName) {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{propertyName} successfully</b>, {
      position: "top-center",

    });

  }
  notifyFailToSave(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  refreshWidgetLogo = () => {
    this.fetchWidgetLogoApi();
    var widgetLogoController = this;
    var widgetLogoTimer = setInterval(function () {
      clearTimeout(widgetLogoTimer);

      if (document.getElementById("inputFile") != null) {
        document.getElementById("inputFile").value = '';
      }
    }, 50);

  }
  submit = () => {
    var widgetLogoController = this;
    var imagePath = document.getElementById("inputFile").value;
    var imagetype = imagePath.split('.')[1];
    var imageUrl = this.state.imagePreviewUrl;
    var imagePath = document.getElementById("inputFile").value;
    var filename = imagePath.replace(/^.*[\\\/]/, '');
    console.log(imagePath);
    var imagetype = imagePath.split('.')[1];
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg)$/i;
    if (!allowedExtensions.exec(imagePath)) {
      widgetLogoController.notifyImageType();
    } else {
      if (this.state.result != null) {
        var widgetData = {
          "projectId": localStorage.getItem("currentProjectId"),
          logoType: imagetype,
          logo: btoa(imageUrl),
          id: this.state.currentLogoId
        }
        $.ajax({
          url: "/api/widget-logo",
          async: false,
          method: 'PATCH',
          headers: {
            'Authorization': "Bearer " + localStorage.getItem("access_token"),
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(widgetData),
          processData: false,
          contentType: "application/json; charset=UTF-8",
          success: function (res) {
            if (res.success === true) {
              widgetLogoController.setState({ hideWidgetLogoDialog: true, imagePreview: true });
              widgetLogoController.notifyWidgetSuccessMsg(filename + " updated as Widget Logo ")
              widgetLogoController.fetchWidgetLogoApi();
              $("#image_Replace").attr("src", widgetLogoController.state.dataUrl);
            } else {
              widgetLogoController.notifyFailToSave(res.result);


            }

          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "/platform/";
            }
          }

        })
      }
      else {
        var widgetData = {
          "projectId": localStorage.getItem("currentProjectId"),
          logoType: imagetype,
          logo: btoa(imageUrl),
        }
        $.ajax({
          url: "/api/widget-logo",
          async: false,
          method: 'POST',
          headers: {
            'Authorization': "Bearer " + localStorage.getItem("access_token"),
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(widgetData),
          processData: false,
          contentType: "application/json; charset=UTF-8",
          success: function (res) {
            if (res.success === true) {
              widgetLogoController.setState({ imagePreview: true });
              widgetLogoController.notifyWidgetSuccessMsg(filename + " saved as Widget Logo ")
              $("#image_Replace").attr("src", widgetLogoController.state.dataUrl);
              widgetLogoController.fetchWidgetLogoApi();
            } else {
              widgetLogoController.notifyFailToSave(res.result);


            }

          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "/platform/";
            }
          }

        })

      }
    }
  }
  fetchWidgetLogoApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var widgetLogoController = this;
    $.ajax({
      url: "/api/widget-logo",
      async: false,
      method: 'GET',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: { projectId: projectId },
      success: function (res) {
        if (res.success === true) {
          if (res.result != null) {
            let id = res.result.id;
            let currentLogo = res.result.dataUrl;
            widgetLogoController.setState({ currentLogoId: id, dataUrl: currentLogo, result: res.result, imagePreviewUrl: currentLogo, imagePreview: true });
          } else {
            widgetLogoController.setState({ currentLogoId: '', dataUrl: '', result: null, imagePreviewUrl: '', imagePreview: false });
            $("#image_Replace").attr("src", "assets/images/bot.ico");
          }
        } else {
          widgetLogoController.notifyFailToSave(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";

        }
      }
    });
  }
  componentDidMount() {
    setTimeout(() => {
      this.fetchWidgetLogoApi();
    }, 300);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchWidgetLogoApi(event.projectId);
      if (document.getElementById("inputFile") != null) {
        document.getElementById("inputFile").value = '';
      }
    });

    if (document.getElementById("inputFile") != null) {
      document.getElementById("inputFile").value = '';
    }
  }
  notifyNoLogoFound = () => {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please upload the widget logo</b>, {
      position: "top-center"
    });
  }


  render() {

    let $imagePreview = (<div className="previewText image-container" style={{ color: "black" }}>
      *file size should be less than 512KB<br /><br />
      <b>Note</b>:Supports only jpg,jpeg,png,svg,gif format</div>);
    if (this.state.imagePreviewUrl) {
      $imagePreview = (<div className="image-container">
        {<img id="img" src={this.state.dataUrl} alt="icon" width="200" />}
      </div>);
    }

    return (
      <div className="wrapper ovrfhide" style={{ height: "800px" }}>
        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />

        {/* Font Awesome Icons */}
        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
        {/* IonIcons */}
        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        {/* Theme style */}
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <link rel="stylesheet" href="assets/css/styles.css" />
        <link rel="stylesheet" href="assets/css/custom-style.css" />
        <link rel="stylesheet" href="assets/css/configBot.css" />

        <div className="card-body ">
          <div className="tab-content col-12 p-0">
            <div className="tab-pane nav-link active show">
              <div className="card-primary mt-2" style={{ marginLeft: "30%" }}>
                < ToastContainer className="Toast-at-center" />
                <div className="p-2" Align="right">
                  <button type="button" className="btn action-button" title="save" onClick={this.submit}> <img className="img-responsive cursor-change" src="./assets/images/baseline_save_white_24dp.png"

                  /></button>

                  <button
                    onClick={() => {
                      this.state.currentLogoId != '' ? this.setState({ hideDeletePopup: true }) : this.notifyNoLogoFound();
                    }}
                    className="btn action-button" title='Delete'>
                    <img className="img-responsive cursor-change" src={"./assets/images/baseline_delete_white_24dp.png"}


                    /></button>
                  <button type="button" className="btn action-button" title="refresh" onClick={this.refreshWidgetLogo}> <img className="img-responsive cursor-change" src="./assets/images/refresh_white_24dp.png"

                  /></button>
                  <br />
                  <br />
                </div>
                <div className="imgPreview">
                  {$imagePreview}

                </div>
                <div className="form-group col-12 pull-left mt-1 p-0">
                  <br /> <input type="file" accept="image/*" id="inputFile" onChange={this.fileChangedHandler} style={{ color: "black" }} />
                </div>
                <div className="raise-form pull-left pt-3">
                </div>
              </div>
            </div>
          </div>
        </div>

        <DialogComponent width='400px' animationSettings={this.settings}
          header='Widget logo' showCloseIcon={true} buttons={this.buttons}
          ref={dialog => this.dialogInstance = dialog}
          visible={this.state.hideDeletePopup} close={this.dialogClose}>
          <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;Do you want to delete the widget logo?<br />Note: Press 'Yes' to delete or press 'No' to decline.
        </DialogComponent>
      </div>


    );

  }

  deleteWidgetLogoApi = () => {

    let widgetLogoController = this;


    $.ajax({
      url: "/api/widget-logo/" + widgetLogoController.state.currentLogoId,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {

        if (res.success === true) {
          widgetLogoController.state.hideDeletePopup = false;
          widgetLogoController.setState(widgetLogoController.state);
          widgetLogoController.notifyWidgetSuccessMsg("Widget logo deleted")
          widgetLogoController.refreshWidgetLogo();

        } else {
          widgetLogoController.notifyFailToDelete(res.result);
          widgetLogoController.state.disabled = false;
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

} export default WidgetLogo;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/WidgetLogo.js